import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["MultiLangActionModal", "multiLangActionModalProps"];
import AsyncUpdateDomainLanguageModal from './AsyncUpdateDomainLanguageModal';
import MultiStepModals from './MultiStepModals';
import { useContentObjectType } from 'content-management-data-lib';
import useDomainLanguage from '../hooks/useDomainLanguage';
import { jsx as _jsx } from "react/jsx-runtime";
const useShouldRenderUpdateDomainLanguageModal = ({
  crmObjects: [crmObject]
}) => {
  const {
    contentGroupObjectType
  } = useContentObjectType();
  const {
    loading: domainLanguageRequestLoading,
    getDomainLanguage
  } = useDomainLanguage({
    skipFetch: !!contentGroupObjectType
  });
  const domainLanguage = getDomainLanguage(crmObject);
  return !contentGroupObjectType && !domainLanguageRequestLoading && !domainLanguage;
};
export const WithUpdateDomainLanguageModal = _ref => {
  let {
      MultiLangActionModal,
      multiLangActionModalProps
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  const shouldRenderUpdateDomainLanguageModal = useShouldRenderUpdateDomainLanguageModal({
    crmObjects: props.crmObjects
  });
  if (shouldRenderUpdateDomainLanguageModal) {
    return /*#__PURE__*/_jsx(MultiStepModals, Object.assign({}, props, {
      ModalsToRender: [AsyncUpdateDomainLanguageModal, MultiLangActionModal],
      modalSpecificProps: multiLangActionModalProps ? [null, multiLangActionModalProps] : undefined
    }));
  }
  return /*#__PURE__*/_jsx(MultiLangActionModal, Object.assign({}, props, multiLangActionModalProps));
};